/**
 * Stytch Hooks Index
 *
 * Exports all Stytch-related hooks organized by functionality
 */
// Session hooks
export * from './session-hooks';
// Magic link hooks
export * from './magic-link-hooks';
// Password hooks
export * from './password-hooks';
// Email OTP hooks
export * from './email-otp-hooks';
// OTP hooks (only export vanilla-specific ones to avoid duplicates)
export { useSendDiscoveryOTP, useAuthenticateDiscoveryOTP } from './vanilla-otp-hooks';
// Discovery and organization hooks
export * from './discovery-hooks';
// Invitation hooks
export * from './invitation-hooks';
// OAuth hooks
export * from './oauth-hooks';
// Session management hooks
export * from './session-management-hooks';
import { useSendDiscoveryEmail, useAuthenticateDiscovery, useAuthenticateMagicLink } from './magic-link-hooks';
import { useResetPasswordByEmail } from './password-hooks';
import { useSendDiscoveryEmailOTP, useAuthenticateDiscoveryEmailOTP } from './email-otp-hooks';
import { useExchangeIntermediateSession, useListDiscoveredOrganizations, useCreateOrganizationViaDiscovery, } from './discovery-hooks';
import { useAuthenticateSession, useExchangeSession, useRevokeSession } from './session-management-hooks';
import { useStartGoogleOAuthDiscovery, useStartMicrosoftOAuthDiscovery, useStartGoogleOneTap, useStartGoogleOneTapDiscovery, useAuthenticateOAuth, useAuthenticateOAuthDiscovery, } from './oauth-hooks';
import { useSendInvitation } from './invitation-hooks';
// Convenience hook that returns all wrapper functions
export function useStytchWrappers() {
    return {
        sendDiscoveryEmail: useSendDiscoveryEmail(),
        authenticateDiscovery: useAuthenticateDiscovery(),
        authenticateMagicLink: useAuthenticateMagicLink(),
        resetPasswordByEmail: useResetPasswordByEmail(),
        sendDiscoveryEmailOTP: useSendDiscoveryEmailOTP(),
        authenticateDiscoveryEmailOTP: useAuthenticateDiscoveryEmailOTP(),
        exchangeIntermediateSession: useExchangeIntermediateSession(),
        listDiscoveredOrganizations: useListDiscoveredOrganizations(),
        createOrganizationViaDiscovery: useCreateOrganizationViaDiscovery(),
        authenticateSession: useAuthenticateSession(),
        exchangeSession: useExchangeSession(),
        revokeSession: useRevokeSession(),
        startGoogleOAuthDiscovery: useStartGoogleOAuthDiscovery(),
        startMicrosoftOAuthDiscovery: useStartMicrosoftOAuthDiscovery(),
        startGoogleOneTap: useStartGoogleOneTap(),
        startGoogleOneTapDiscovery: useStartGoogleOneTapDiscovery(),
        authenticateOAuth: useAuthenticateOAuth(),
        authenticateOAuthDiscovery: useAuthenticateOAuthDiscovery(),
        sendInvitation: useSendInvitation(),
    };
}
